import { Colors, Services } from '@sigma-frontend-libs/commons'
import { TaskFrequency } from '@sigmasms/shared-types'

import { buttonModes, components, icons, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import selectorOwner from '@/components/selector/owner'
import billingsFormBasic from '@/components/services/billings/form/basic'
import { billingsOperationsFrequencies } from '@/components/services/tasks/utils'
import sticker from '@/components/sticker'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${Services.tasks}.labels.title`),
        dense: true,
        required: true,
        autofocus: true,
        clearable: true,
        details: false,
        mask: /^.{0,255}$/
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}

function renderBillingsFormBasic(h) {
  return h(
    billingsFormBasic,
    {
      props: {
        value: this.proxy.data,
        currency: this.currency,
        required: true
      },
      on: {
        input: event => {
          this.proxy.data = event
        }
      }
    }
  )
}

function renderFrequency(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.data.frequency,
        label: this.getTranslate(`${Services.tasks}.labels.data.frequency`),
        items: billingsOperationsFrequencies.map(frequency => {
          return {
            title: this.getTranslate(`${Services.tasks}.frequencies.${frequency}`),
            value: frequency
          }
        }),
        required: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.data.frequency = event
        }
      }
    }
  )
}

function renderDate(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-end'],
        closeOnContentClick: false
      }
    },
    [
      h(
        sticker,
        {
          props: {
            value: this.date.title,
            label: this.date.label,
            width: '100%',
            icon: icons.event,
            color: Colors.grey,
            to: { service: undefined }
          },
          slot: 'activator'
        }
      ),
      h(
        components['date-picker'],
        {
          props: {
            value: this.date.value,
            localeTag: this.locale,
            range: this.proxy.data.frequency !== TaskFrequency.once,
            min: this.date.min
          },
          on: {
            input: event => {
              if (this.proxy.data.frequency === TaskFrequency.once) {
                this.proxy.startsAt = event
              } else {
                this.proxy.startsAt = event[0]
                this.proxy.data.endsAt = event[1]
              }
            }
          }
        }
      ),
      h(
        'div',
        {
          class: 'tasks-form__date-footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.clear'),
                size: sizes.small,
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.proxy.startsAt = undefined
                  this.proxy.data.endsAt = undefined
                }
              }
            }
          )
        ]
      )
    ]
  )
}

function renderSelectorOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        itemsDisabled: [ this.account.id ],
        dense: true,
        required: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.tasks}-form`
    },
    [
      renderTitleField.call(this, h),
      renderBillingsFormBasic.call(this, h),
      renderFrequency.call(this, h),
      renderDate.call(this, h),
      renderSelectorOwner.call(this, h)
    ]
  )
}
